export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14261.bbc4560f.jpg";